import React, { ReactNode } from 'react';

// Types
import { UserContext } from '@zola-helpers/client/dist/es/@types';

// Components
import Nav from 'components/Nav';
import { PreauthFooterV3 } from '@zola/zola-ui/src/components/PreAuthV3';

// Styles
import { PageContainer } from './StaticContentPageContainer.styles';

type StaticContentPageContainerProps = {
  className?: string;
  navHTML: string;
  userCtx: UserContext;
  children: ReactNode;
  inApp?: boolean;
};

const StaticContentPageContainer = ({
  className,
  children,
  userCtx,
  navHTML,
  inApp = false,
}: StaticContentPageContainerProps): JSX.Element => {
  const isGuest = userCtx ? Boolean(userCtx.is_guest) : true;
  return (
    <>
      {!inApp && (
        <Nav
          navHTML={navHTML}
          showPromo
          user={userCtx}
          disableSecondary
          disablePrimaryNavCollapse
        />
      )}
      <PageContainer className={className} isGuest={isGuest}>
        <div className={className}>
          {children}
          {!inApp && <PreauthFooterV3 isGuest={isGuest} />}
        </div>
      </PageContainer>
    </>
  );
};

export default StaticContentPageContainer;
